

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { fetchFlagship } from '../api/flagshipApi';

// const BASE_URL = "https://www.assocham.org/assocham_backend";

// const PODCAST_VIDEOS = [
//   { id: "U3JGpV6nI9Q", title: "ASSOCHAM Voice Podcast | Ep. 1" },
//   { id: "VM_jpeUvfyw", title: "ASSOCHAM Voice Ep. 2" },
//   { id: "Y7Rl-e_yJUk", title: "ASSOCHAM Voice Ep. 3" },
//   { id: "pl3r5yT6I-0", title: "ASSOCHAM Voice Ep. 4" },
//   { id: "Iwbt2yZaKSc", title: "ASSOCHAM Voice Ep. 5" },
// ];

// const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// function getEventImage(event) {
//   const image = event.image;
//   if (!image) return `${BASE_URL}/assets/images/events-banner-main.jpg`;
//   if (image.startsWith("http")) return image;
//   if (image.startsWith("/")) return `${BASE_URL}${image}`;
//   if (image.startsWith("assets/")) return `${BASE_URL}/${image}`;
//   return `${BASE_URL}/assets/images/${image}`;
// }

// // Parses the same "01 Jan, 2026" style date string used in EventPage.jsx
// function parseEventDate(dateStr) {
//   const date = dateStr || "01 Jan, 2026";
//   const match = date.match(/(\d{1,2})\s+([A-Za-z]{3})[^\d]*(20\d{2})/);
//   const day = match?.[1] || "01";
//   const month = match?.[2] || "Jan";
//   const year = match?.[3] || "2026";
//   const monthIndex = MONTH_NAMES.findIndex((m) => m.toLowerCase() === month.slice(0, 3).toLowerCase());
//   const dateObj = new Date(Number(year), monthIndex >= 0 ? monthIndex : 0, Number(day));
//   return { day, month: month.toUpperCase(), year, dateObj };
// }

// const FlagshipAndEvent = () => {
//   const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [isHoveringPodcast, setIsHoveringPodcast] = useState(false);

//   const [currentFlagshipIndex, setCurrentFlagshipIndex] = useState(0);
//   const [flagshipProgress, setFlagshipProgress] = useState(0);

//   // Flagship items from DB
//   const [flagshipItems, setFlagshipItems] = useState([]);
//   const [flagshipLoading, setFlagshipLoading] = useState(true);

//   // Real forthcoming events from DB
//   const [events, setEvents] = useState([]);
//   const [eventsLoading, setEventsLoading] = useState(true);
//   const [eventsError, setEventsError] = useState("");

//   const currentVideo = PODCAST_VIDEOS[currentVideoIndex];
//   const currentFlagship = flagshipItems[currentFlagshipIndex];

//   // Auto Slider for Podcast
//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (!isHoveringPodcast) {
//         setCurrentVideoIndex((prev) => (prev + 1) % PODCAST_VIDEOS.length);
//         setIsPlaying(false);
//       }
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [isHoveringPodcast]);

//   // Auto Slider for Flagship Images
//   useEffect(() => {
//     if (flagshipItems.length === 0) return;

//     const interval = setInterval(() => {
//       setFlagshipProgress((prev) => {
//         if (prev >= 100) {
//           setCurrentFlagshipIndex((prevIndex) => (prevIndex + 1) % flagshipItems.length);
//           return 0;
//         }
//         return prev + 2;
//       });
//     }, 100);
//     return () => clearInterval(interval);
//   }, [flagshipItems.length]);

//   // Fetch Flagship items from DB
//   useEffect(() => {
//     let alive = true;

//     fetchFlagship()
//       .then((data) => {
//         if (!alive) return;
//         setFlagshipItems(data);
//       })
//       .catch((err) => console.error("Flagship fetch failed:", err))
//       .finally(() => {
//         if (alive) setFlagshipLoading(false);
//       });

//     return () => {
//       alive = false;
//     };
//   }, []);

//   // Fetch forthcoming events from DB — same endpoint as EventPage.jsx, latest 4 only
//   useEffect(() => {
//     fetch(`${BASE_URL}/api/get_events.php`)
//       .then(async (res) => {
//         const json = await res.json();
//         if (!res.ok || !json.success) throw new Error(json.error || "Could not load events.");
//         return json.data;
//       })
//       .then((data) => {
//         const forthcoming = (data || [])
//           .filter((e) => e.status === "forthcoming")
//           .sort((a, b) => parseEventDate(a.date).dateObj - parseEventDate(b.date).dateObj);
//         setEvents(forthcoming.slice(0, 4));
//       })
//       .catch((e) => setEventsError(e.message))
//       .finally(() => setEventsLoading(false));
//   }, []);

//   const handleVideoClick = () => {
//     setIsPlaying(!isPlaying);
//   };

//   return (
//     <div className="bg-[#fff8f5] py-12 px-4 font-sans">
//       <div className="mx-auto text-center mb-10">
//         <p className="text-[14px] text-gray-600 mt-3 max-w-2xl mx-auto leading-relaxed font-rethink">
//           Stay updated with the latest discussions, upcoming programs and flagship initiatives.
//         </p>
//       </div>

//       <div className="mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

//         {/* LEFT: PODCAST */}
//         <div className="lg:col-span-4 bg-[#ffffff] rounded-3xl shadow-xl flex flex-col h-[520px] overflow-hidden">
//           <div className="p-6 border-b border-gray-100">
//             <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink text-center lg:text-left">
//                ASSOCHAM Voice Podcast
//             </h3>
//           </div>

//           {/* Video Container */}
//           <div
//             className="px-5 pt-4 pb-3 bg-[#FFFFFF] cursor-pointer"
//             onMouseEnter={() => setIsHoveringPodcast(true)}
//             onMouseLeave={() => setIsHoveringPodcast(false)}
//             onClick={handleVideoClick}
//           >
//             <div className="relative rounded-2xl overflow-hidden shadow-md h-[240px] bg-black ring-1 ring-gray-200">
//               {isPlaying ? (
//                 <iframe
//                   width="100%"
//                   height="100%"
//                   src={`https://www.youtube.com/embed/${currentVideo.id}?autoplay=1&rel=0`}
//                   title="ASSOCHAM Podcast"
//                   frameBorder="0"
//                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                   allowFullScreen
//                 ></iframe>
//               ) : (
//                 <img
//                   src={`https://img.youtube.com/vi/${currentVideo.id}/maxresdefault.jpg`}
//                   alt={currentVideo.title}
//                   className="w-full h-full object-cover"
//                 />
//               )}

//               {!isPlaying && (
//                 <div className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/50 transition-all">
//                   <div className="w-20 h-20 bg-[#FFFFFF] rounded-full flex items-center justify-center shadow-xl">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-[#da2128] ml-1" fill="currentColor" viewBox="0 0 24 24">
//                       <path d="M8 5.14v14l11-7z" />
//                     </svg>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Progress Bar */}
//           <div className="h-1 bg-gray-100 mx-6 mt-2 rounded-full overflow-hidden">
//             <div
//               className="h-full bg-[#da2128] rounded-full transition-all"
//               style={{ animation: isHoveringPodcast ? "none" : "progress 5s linear infinite" }}
//             ></div>
//           </div>

//           <div className="flex-1 overflow-hidden relative py-5 px-6">
//             <div className="podcast-step-scroll p-2 space-y-4">
//               {[...PODCAST_VIDEOS, ...PODCAST_VIDEOS, ...PODCAST_VIDEOS].map((video, idx) => (
//                 <div
//                   key={idx}
//                   onClick={() => {
//                     setCurrentVideoIndex(PODCAST_VIDEOS.indexOf(video) % PODCAST_VIDEOS.length);
//                     setIsPlaying(false);
//                   }}
//                   className={`p-4 rounded-2xl cursor-pointer transition-all hover:bg-gray-50 ${
//                     video.id === currentVideo.id ? "bg-[#da2128]/5 ring-1 ring-[#da2128]/20" : ""
//                   }`}
//                 >
//                   <p className={`text-[14px] leading-snug transition-all font-rethink line-clamp-1 ${
//                     video.id === currentVideo.id
//                       ? "text-[#da2128] font-medium"
//                       : "text-neutral-700"
//                   }`}>
//                     {video.title}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* MIDDLE: UPCOMING EVENTS (real data from DB) */}
//         <div className="lg:col-span-5 bg-[#ffffff] rounded-3xl p-6 shadow-xl flex flex-col" style={{ height: "520px" }}>
//           <div className="flex items-center justify-between mb-6 border-b border-gray-100 pb-4">
//             <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink">
//               Forthcoming Events
//             </h3>
//             <Link to="/events" className="text-red-600 text-sm font-medium hover:underline">
//               View All →
//             </Link>
//           </div>

//           <div className="space-y-4 flex-1 overflow-y-auto pr-2 custom-scrollbar">
//             {eventsLoading ? (
//               Array.from({ length: 4 }).map((_, i) => (
//                 <div key={i} className="flex gap-4 animate-pulse">
//                   <div className="w-24 h-20 rounded-xl bg-gray-200 flex-shrink-0" />
//                   <div className="flex-1 space-y-2 py-1">
//                     <div className="h-3 w-16 bg-gray-200 rounded" />
//                     <div className="h-4 w-full bg-gray-200 rounded" />
//                     <div className="h-3 w-2/3 bg-gray-200 rounded" />
//                   </div>
//                 </div>
//               ))
//             ) : eventsError ? (
//               <p className="text-sm text-red-600">{eventsError}</p>
//             ) : events.length === 0 ? (
//               <p className="text-sm text-gray-500">No upcoming events right now.</p>
//             ) : (
//               events.map((event) => {
//                 const { day, month } = parseEventDate(event.date);
//                 const isExternal = Number(event.externalIndicator) === 1 && event.externalUrl;
//                 const to = `/event-details/${event.slug}`;
//                 const externalUrl = event.externalUrl?.startsWith("http")
//                   ? event.externalUrl
//                   : `${BASE_URL}/${event.externalUrl || ""}`;

//                 const cardContent = (
//                   <div className="flex gap-4 p-[5px] group rounded-2xl border border-gray-200 bg-[#fff6f6] shadow-sm transition hover:shadow-md">
//                     <img
//                       src={getEventImage(event)}
//                       alt={event.title}
//                       className="w-24 h-20 object-contain rounded-xl flex-shrink-0"
//                       onError={(e) => { e.currentTarget.src = `${BASE_URL}/assets/images/events-banner-main.jpg`; }}
//                     />
//                     <div className="flex-1 min-w-0">
//                       <div className="text-xs text-gray-500">
//                         {month} <span className="font-bold text-gray-900">{day}</span>
//                       </div>
//                       <h4 className="font-semibold leading-tight mt-1 text-gray-900 line-clamp-1">
//                         {event.title}
//                       </h4>
//                       <p className="text-sm text-gray-600 mt-1 line-clamp-1">
//                         {event.location || event.venue || event.category || ""}
//                       </p>
//                     </div>
//                   </div>
//                 );

//                 return isExternal ? (
//                   <a
//                     key={event.id}
//                     href={externalUrl}
//                     target="_blank"
//                     rel="noreferrer"
//                     className="block hover:opacity-90 transition-opacity"
//                   >
//                     {cardContent}
//                   </a>
//                 ) : (
//                   <Link
//                     key={event.id}
//                     to={to}
//                     className="block hover:opacity-90 transition-opacity"
//                   >
//                     {cardContent}
//                   </Link>
//                 );
//               })
//             )}
//           </div>
//         </div>

//         {/* RIGHT: FLAGSHIP (real data from DB, hyperlinked) */}
//         <div className="lg:col-span-3 bg-[#FFFFFF] rounded-3xl overflow-hidden shadow-xl flex flex-col">
//           <div className="relative h-[470px] overflow-hidden">
//             {flagshipLoading && (
//               <div className="w-full h-full flex items-center justify-center bg-gray-100 animate-pulse text-gray-400 text-sm">
//                 Loading...
//               </div>
//             )}

//             {!flagshipLoading && flagshipItems.length === 0 && (
//               <div className="w-full h-full flex items-center justify-center bg-gray-100 text-gray-400 text-sm">
//                 No flagship items found
//               </div>
//             )}

//             {!flagshipLoading && currentFlagship && (
//               currentFlagship.link ? (
//                 <a href={currentFlagship.link} target="_blank" rel="noopener noreferrer">
//                   <img
//                     src={currentFlagship.image}
//                     alt="Flagship"
//                     className="w-full h-full object-cover mt-[70px]"
//                   />
//                 </a>
//               ) : (
//                 <img
//                   src={currentFlagship.image}
//                   alt="Flagship"
//                   className="w-full h-full object-cover mt-[70px]"
//                 />
//               )
//             )}

//             <div className="absolute top-4 left-1 px-5 py-2.5 z-10">
//               <h3 className="text-[18px] text-[#da2128] font-semibold font-rethink tracking-tight">
//                 Flagship
//               </h3>
//             </div>

//             {flagshipItems.length > 0 && (
//               <>
//                 <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#FFFFFF]/30">
//                   <div className="h-1 bg-[#da2128] transition-all" style={{ width: `${flagshipProgress}%` }}></div>
//                 </div>

//                 <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-20">
//                   {flagshipItems.map((_, idx) => (
//                     <button
//                       key={idx}
//                       onClick={() => { setCurrentFlagshipIndex(idx); setFlagshipProgress(0); }}
//                       className={`w-3 h-3 rounded-full transition-all ${idx === currentFlagshipIndex ? 'bg-[#FFFFFF] scale-125' : 'bg-[#FFFFFF]/50'}`}
//                     />
//                   ))}
//                 </div>
//               </>
//             )}
//           </div>

//           {currentFlagship?.link ? (
//             <a
//               href={currentFlagship.link}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="w-full text-center bg-[#dc262694] hover:bg-red-700 text-white py-4 font-medium transition-colors mt-auto rounded-bl-[10px] rounded-br-[10px]"
//             >
//               View More →
//             </a>
//           ) : (
//             <Link
//               to="/events"
//               className="w-full text-center bg-[#dc262694] hover:bg-red-700 text-white py-4 font-medium transition-colors mt-auto rounded-bl-[10px] rounded-br-[10px]"
//             >
//               View More →
//             </Link>
//           )}
//         </div>
//       </div>

//       <style jsx>{`
//         .podcast-step-scroll {
//           animation: podcastStep 25s linear infinite;
//         }
//         @keyframes podcastStep {
//           0%, 18%    { transform: translateY(0); }
//           20%, 38%   { transform: translateY(-78px); }
//           40%, 58%   { transform: translateY(-156px); }
//           60%, 78%   { transform: translateY(-234px); }
//           80%, 98%   { transform: translateY(-312px); }
//           100%       { transform: translateY(-312px); }
//         }
//         .podcast-step-scroll:hover {
//           animation-play-state: paused;
//         }
//         @keyframes progress {
//           from { width: 0%; }
//           to { width: 100%; }
//         }
//         .line-clamp-1 {
//           display: -webkit-box;
//           -webkit-line-clamp: 1;
//           -webkit-box-orient: vertical;
//           overflow: hidden;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default FlagshipAndEvent;





// new code 






import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchFlagship } from '../api/flagshipApi';

const BASE_URL = "https://www.assocham.org/assocham_backend";
const PLAYLIST_ID = "PLHQFPkf6bDfG6hRSlSBIkp69OB6QJSF4Q";

const PODCAST_VIDEOS = [
  { id: "5A1Jr1dnDPY", title: "ASSOCHAM Voice Podcast | Mr. Sanjay Nayar on Investment, Startups and Finance" },
  { id: "FE1qceQog-M", title: "ASSOCHAM Podcast Teaser | Mr. Sanjay Nayar on Investment, Startups and Finance" },
  { id: "VM_jpeUvfyw", title: "ASSOCHAM Voice Podcast | EP 1: The Growth Formula for Viksit Bharat" },
  { id: "b7VnWEghlk4", title: "ASSOCHAM Podcast Teaser | Mr. Amitabh Chaudhry on new growth opportunities for India’s economy." },
  { id: "bgGnGtGX6eI", title: "ASSOCHAM Voice Podcast | Real Growth isn't Subsidised; It's Built" },
  { id: "U3JGpV6nI9Q", title: "ASSOCHAM Voice Podcast | Ep. 1: India’s Next Big Moves, Decoded with Mr. Nirmal K. Minda" },
  { id: "5unr65v-GqE", title: "ASSOCHAM Podcast Teaser | Nirmal K. Minda on India’s Next Big Moves | ASSOCHAM Voices" },
  { id: "shtDzUye_k4", title: "India’s Next Growth Chapter | Saurabh Sanyal in Conversation with Sumit Chaturvedi | ASSOCHAM Voice" },
  { id: "c7iQG6QH1dU", title: "India’s Next Manufacturing Leap | Mr. Saurabh Sanyal | ASSOCHAM Voice Teaser" },
  { id: "5unr65v-GqE", title: "ASSOCHAM Podcast Teaser | Nirmal K. Minda on India’s Next Big Moves | ASSOCHAM Voices" }
];

const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function getEventImage(event) {
  const image = event.image;
  if (!image) return `${BASE_URL}/assets/images/events-banner-main.jpg`;
  if (image.startsWith("http")) return image;
  if (image.startsWith("/")) return `${BASE_URL}${image}`;
  if (image.startsWith("assets/")) return `${BASE_URL}/${image}`;
  return `${BASE_URL}/assets/images/${image}`;
}

function parseEventDate(dateStr) {
  const date = dateStr || "01 Jan, 2026";
  const match = date.match(/(\d{1,2})\s+([A-Za-z]{3})[^\d]*(20\d{2})/);
  const day = match?.[1] || "01";
  const month = match?.[2] || "Jan";
  const year = match?.[3] || "2026";
  const monthIndex = MONTH_NAMES.findIndex((m) => m.toLowerCase() === month.slice(0, 3).toLowerCase());
  const dateObj = new Date(Number(year), monthIndex >= 0 ? monthIndex : 0, Number(day));
  return { day, month: month.toUpperCase(), year, dateObj };
}

// Smart YouTube thumbnail with guaranteed fallback
const YoutubeThumb = ({ videoId, alt, className }) => {
  const [src, setSrc] = useState(
    `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
  );

  const handleError = () => {
    if (src.includes("maxresdefault")) {
      setSrc(`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`);
    } else if (src.includes("hqdefault")) {
      setSrc(`https://img.youtube.com/vi/${videoId}/mqdefault.jpg`);
    } else {
      setSrc(`${BASE_URL}/assets/images/events-banner-main.jpg`);
    }
  };

  return (
    <img
      src={src}
      onError={handleError}
      alt={alt}
      className={className}
    />
  );
};

const FlagshipAndEvent = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHoveringPodcast, setIsHoveringPodcast] = useState(false);

  const [currentFlagshipIndex, setCurrentFlagshipIndex] = useState(0);
  const [flagshipProgress, setFlagshipProgress] = useState(0);

  const [flagshipItems, setFlagshipItems] = useState([]);
  const [flagshipLoading, setFlagshipLoading] = useState(true);

  const [events, setEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);
  const [eventsError, setEventsError] = useState("");

  const currentVideo = PODCAST_VIDEOS[currentVideoIndex];
  const currentFlagship = flagshipItems[currentFlagshipIndex];

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHoveringPodcast && !isPlaying) {
        setCurrentVideoIndex((prev) => (prev + 1) % PODCAST_VIDEOS.length);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [isHoveringPodcast, isPlaying]);

  useEffect(() => {
    if (flagshipItems.length === 0) return;

    const interval = setInterval(() => {
      setFlagshipProgress((prev) => {
        if (prev >= 100) {
          setCurrentFlagshipIndex((prevIndex) => (prevIndex + 1) % flagshipItems.length);
          return 0;
        }
        return prev + 2;
      });
    }, 100);
    return () => clearInterval(interval);
  }, [flagshipItems.length]);

  useEffect(() => {
    let alive = true;

    fetchFlagship()
      .then((data) => {
        if (!alive) return;
        setFlagshipItems(data);
      })
      .catch((err) => console.error("Flagship fetch failed:", err))
      .finally(() => {
        if (alive) setFlagshipLoading(false);
      });

    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    fetch(`${BASE_URL}/api/get_events.php`)
      .then(async (res) => {
        const json = await res.json();
        if (!res.ok || !json.success) throw new Error(json.error || "Could not load events.");
        return json.data;
      })
      .then((data) => {
        const forthcoming = (data || [])
          .filter((e) => e.status === "forthcoming")
          .sort((a, b) => parseEventDate(a.date).dateObj - parseEventDate(b.date).dateObj);
        setEvents(forthcoming.slice(0, 4));
      })
      .catch((e) => setEventsError(e.message))
      .finally(() => setEventsLoading(false));
  }, []);

  const handleVideoClick = () => {
    setIsPlaying(!isPlaying);
  };

  const playerSrc = isPlaying
    ? `https://www.youtube.com/embed/${currentVideo.id}?autoplay=1&rel=0&list=${PLAYLIST_ID}`
    : "";

  return (
    <div className="bg-[#fff8f5] py-12 px-4 font-sans">
      <div className="mx-auto text-center mb-10">
        <p className="text-[14px] text-gray-600 mt-3 max-w-2xl mx-auto leading-relaxed font-rethink">
          Stay updated with the latest discussions, upcoming programs and flagship initiatives.
        </p>
      </div>

      <div className="mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

        {/* LEFT: PODCAST */}
        <div className="lg:col-span-4 bg-[#ffffff] rounded-3xl shadow-xl flex flex-col h-[520px] overflow-hidden">
          <div className="p-6 border-b border-gray-100">
            <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink text-center lg:text-left">
              ASSOCHAM Voice Podcast
            </h3>
          </div>

          <div
            className="px-5 pt-4 pb-3 bg-[#FFFFFF] cursor-pointer"
            onMouseEnter={() => setIsHoveringPodcast(true)}
            onMouseLeave={() => setIsHoveringPodcast(false)}
            onClick={handleVideoClick}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-md h-[240px] bg-black ring-1 ring-gray-200">
              {isPlaying ? (
                <iframe
                  width="100%"
                  height="100%"
                  src={playerSrc}
                  title="ASSOCHAM Podcast"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <YoutubeThumb
                  key={currentVideo.id}
                  videoId={currentVideo.id}
                  alt={currentVideo.title}
                  className="w-full h-full object-cover"
                />
              )}

              {!isPlaying && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/50 transition-all">
                  <div className="w-20 h-20 bg-[#FFFFFF] rounded-full flex items-center justify-center shadow-xl">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-[#da2128] ml-1" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5.14v14l11-7z" />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="h-1 bg-gray-100 mx-6 mt-2 rounded-full overflow-hidden">
            <div
              className="h-full bg-[#da2128] rounded-full transition-all"
              style={{ animation: isHoveringPodcast || isPlaying ? "none" : "progress 5s linear infinite" }}
            ></div>
          </div>

          <div className="flex-1 overflow-hidden relative py-4 px-5">
            <div className="podcast-scroll h-full overflow-y-auto pr-1 space-y-2">
              {PODCAST_VIDEOS.map((video, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    setCurrentVideoIndex(idx);
                    setIsPlaying(false);
                  }}
                  className={`p-3 rounded-2xl cursor-pointer transition-all hover:bg-gray-50 ${
                    idx === currentVideoIndex ? "bg-[#da2128]/5 ring-1 ring-[#da2128]/20" : ""
                  }`}
                >
                  <p className={`text-[13px] leading-snug transition-all font-rethink line-clamp-1 ${
                    idx === currentVideoIndex
                      ? "text-[#da2128] font-medium"
                      : "text-neutral-700"
                  }`}>
                    {video.title}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* MIDDLE: UPCOMING EVENTS */}
        <div className="lg:col-span-5 bg-[#ffffff] rounded-3xl p-6 shadow-xl flex flex-col" style={{ height: "520px" }}>
          <div className="flex items-center justify-between mb-6 border-b border-gray-100 pb-4">
            <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink">
              Forthcoming Events
            </h3>
            <Link to="/events" className="text-red-600 text-sm font-medium hover:underline">
              View All →
            </Link>
          </div>

          <div className="space-y-4 flex-1 overflow-y-auto pr-2 custom-scrollbar">
            {eventsLoading ? (
              Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="flex gap-4 animate-pulse">
                  <div className="w-24 h-20 rounded-xl bg-gray-200 flex-shrink-0" />
                  <div className="flex-1 space-y-2 py-1">
                    <div className="h-3 w-16 bg-gray-200 rounded" />
                    <div className="h-4 w-full bg-gray-200 rounded" />
                    <div className="h-3 w-2/3 bg-gray-200 rounded" />
                  </div>
                </div>
              ))
            ) : eventsError ? (
              <p className="text-sm text-red-600">{eventsError}</p>
            ) : events.length === 0 ? (
              <p className="text-sm text-gray-500">No upcoming events right now.</p>
            ) : (
              events.map((event) => {
                const { day, month } = parseEventDate(event.date);
                const isExternal = Number(event.externalIndicator) === 1 && event.externalUrl;
                const to = `/event-details/${event.slug}`;
                const externalUrl = event.externalUrl?.startsWith("http")
                  ? event.externalUrl
                  : `${BASE_URL}/${event.externalUrl || ""}`;

                const cardContent = (
                  <div className="flex gap-4 p-[5px] group rounded-2xl border border-gray-200 bg-[#fff6f6] shadow-sm transition hover:shadow-md">
                    <img
                      src={getEventImage(event)}
                      alt={event.title}
                      className="w-24 h-20 object-contain rounded-xl flex-shrink-0"
                      onError={(e) => { e.currentTarget.src = `${BASE_URL}/assets/images/events-banner-main.jpg`; }}
                    />
                    <div className="flex-1 min-w-0">
                      <div className="text-xs text-gray-500">
                        {month} <span className="font-bold text-gray-900">{day}</span>
                      </div>
                      <h4 className="font-semibold leading-tight mt-1 text-gray-900 line-clamp-1">
                        {event.title}
                      </h4>
                      <p className="text-sm text-gray-600 mt-1 line-clamp-1">
                        {event.location || event.venue || event.category || ""}
                      </p>
                    </div>
                  </div>
                );

                return isExternal ? (
                  <a key={event.id} href={externalUrl} target="_blank" rel="noreferrer" className="block hover:opacity-90 transition-opacity">
                    {cardContent}
                  </a>
                ) : (
                  <Link key={event.id} to={to} className="block hover:opacity-90 transition-opacity">
                    {cardContent}
                  </Link>
                );
              })
            )}
          </div>
        </div>

        {/* RIGHT: FLAGSHIP */}
        <div className="lg:col-span-3 bg-[#FFFFFF] rounded-3xl overflow-hidden shadow-xl flex flex-col">
          <div className="relative h-[470px] overflow-hidden bg-[#F8F3E9]">
            {flagshipLoading && (
              <div className="w-full h-full flex items-center justify-center bg-gray-100 animate-pulse text-gray-400 text-sm">
                Loading...
              </div>
            )}

            {!flagshipLoading && flagshipItems.length === 0 && (
              <div className="w-full h-full flex items-center justify-center bg-gray-100 text-gray-400 text-sm">
                No flagship items found
              </div>
            )}

            {!flagshipLoading && currentFlagship && (
              currentFlagship.link ? (
                <a href={currentFlagship.link} target="_blank" rel="noopener noreferrer">
                  <img src={currentFlagship.image} alt="Flagship" className="w-full h-[85%] object-contain mt-[70px]" />
                </a>
              ) : (
                <img src={currentFlagship.image} alt="Flagship" className="w-full h-[85%] object-contain mt-[70px]" />
              )
            )}

            <div className="absolute top-4 left-1 px-5 py-2.5 z-10">
              <h3 className="text-[18px] text-[#da2128] font-semibold font-rethink tracking-tight">
                Flagship
              </h3>
            </div>

            {flagshipItems.length > 0 && (
              <>
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#FFFFFF]/30">
                  <div className="h-1 bg-[#da2128] transition-all" style={{ width: `${flagshipProgress}%` }}></div>
                </div>

                <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-20">
                  {flagshipItems.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => { setCurrentFlagshipIndex(idx); setFlagshipProgress(0); }}
                      className={`w-3 h-3 rounded-full transition-all ${idx === currentFlagshipIndex ? 'bg-[#FFFFFF] scale-125' : 'bg-[#FFFFFF]/50'}`}
                    />
                  ))}
                </div>
              </>
            )}
          </div>

          {currentFlagship?.link ? (
            <a href={currentFlagship.link} target="_blank" rel="noopener noreferrer" className="w-full text-center bg-[#dc262694] hover:bg-red-700 text-white py-4 font-medium transition-colors mt-auto rounded-bl-[10px] rounded-br-[10px]">
              View More →
            </a>
          ) : (
            <Link to="/events" className="w-full text-center bg-[#dc262694] hover:bg-red-700 text-white py-4 font-medium transition-colors mt-auto rounded-bl-[10px] rounded-br-[10px]">
              View More →
            </Link>
          )}
        </div>
      </div>

      <style jsx>{`
        .podcast-scroll::-webkit-scrollbar { width: 6px; }
        .podcast-scroll::-webkit-scrollbar-thumb { background: #da2128; border-radius: 9999px; }
        .podcast-scroll::-webkit-scrollbar-track { background: #f3f4f6; border-radius: 9999px; }
        @keyframes progress { from { width: 0%; } to { width: 100%; } }
        .line-clamp-1 {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default FlagshipAndEvent;